// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.refine-search-container {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 10px;
}
.refine-search-container .refine-search-input {
  color: #6A8991;
  margin: 0 20px;
  min-width: 150px;
  outline: none;
  max-height: 60px;
  overflow: auto;
}
.refine-search-container .refine-search-input::before {
  content: attr(data-placeholder);
  color: #6A8991;
}`, "",{"version":3,"sources":["webpack://./src/pages/Mapping/SetupRow/RefineSearchComponents/RefineSearchComponents.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AACD;AACC;EACC,cAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;AACF;AAEC;EACC,+BAAA;EACA,cAAA;AAAF","sourcesContent":[".refine-search-container {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolumn-gap: 10px;\n\n\t.refine-search-input {\n\t\tcolor: #6A8991;\n\t\tmargin: 0 20px;\n\t\tmin-width: 150px;\n\t\toutline: none;\n\t\tmax-height: 60px;\n\t\toverflow: auto;\n\t}\n\n\t.refine-search-input::before {\n\t\tcontent: attr(data-placeholder);\n\t\tcolor: #6A8991;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
